import { Badge } from '@bbpos/ui';
import type { QuotationStatus } from './types';

interface StatusMeta {
  label: string;
  badgeVariant: 'info' | 'success' | 'danger' | 'draft';
  customClass?: string;
}

const STATUS_MAP: Record<QuotationStatus, StatusMeta> = {
  ACTIVE: { label: 'Active', badgeVariant: 'info' },
  CONVERTED: { label: 'Converted', badgeVariant: 'success' },
  EXPIRED: { label: 'Expired', badgeVariant: 'danger' },
  APPROVED: {
    label: 'Approved',
    badgeVariant: 'info',
    customClass: 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300',
  },
  CANCELLED: { label: 'Cancelled', badgeVariant: 'draft' },
  REJECTED: { label: 'Declined', badgeVariant: 'danger' },
};

export interface QuotationStatusBadgeProps {
  status: QuotationStatus;
  size?: 'sm' | 'md';
}

export function QuotationStatusBadge({ status, size = 'sm' }: QuotationStatusBadgeProps) {
  const meta = STATUS_MAP[status] ?? STATUS_MAP.ACTIVE;

  if (meta.customClass) {
    return (
      <span
        className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${meta.customClass}`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {meta.label}
      </span>
    );
  }

  return (
    <Badge variant={meta.badgeVariant} size={size}>
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {meta.label}
      </span>
    </Badge>
  );
}
